import { Reducer } from "redux";

import { GetConfigVariablesActionDispatchTypes } from "../constants/AppConfigs";
import { GetConfigVariablesDispatchTypes } from "../models/DispatchTypes/AppConfigs";
import { AppConfigsResponse } from "../models/Api/AppConfigs";

const initialState: AppConfigsResponse = {
  loading: false,
  response: {
    REACT_APP_TEMPO_CONFIG_URL: "",
    REACT_APP_TEMPO_CONFIG_URL_USER: "",
    REACT_APP_TEMPO_CONFIG_URL_REFERRAL: "",
    REACT_APP_TEMPO_CONFIG_URL_OPERATOR: "",
    REACT_APP_TEMPO_APPINSIGHTS_CONNECTION_STRING: "",
    REACT_APP_TEMPO_CLIENT_ID: "",
    REACT_APP_TEMPO_HOST_CONFIG_URL_SCHEDULER: "",
    REACT_APP_TEMPO_CONFIG_URL_BLOB: "",
    REACT_APP_TEMPO_CONFIG_URL_CHECK_ELIGIBILITY: "",
    REACT_APP_TEMPO_CONFIG_URL_NOTE: "",
    REACT_APP_TEMPO_HOST_CONFIG_URL_PAYER_ELIGIBILITY: "",
    REACT_APP_TEMPO_LOGIN_URL: "",
    REACT_APP_TEMPO_DEBUG: "0",
    REACT_APP_TEMPO_GOOGLE_MAP_KEY: "",
    REACT_APP_TEMPO_SURVEY_JS_KEY: "",
    REACT_APP_TEMPO_GOOGLE_MAP_API_URL: "",
    REACT_APP_TEMPO_DOCUMENT_MAX_SIZE: "",
    REACT_APP_TEMPO_DOCUMENT_MIN_SIZE: "",
    REACT_APP_TEMPO_FAX_MAX_SIZE: "",
    REACT_APP_TEMPO_IS_PRODUCTION_ENV: "1",
    REACT_APP_TEMPO_DINA_DEFAULT_URL: "",
    REACT_APP_TEMPO_API_CALL_INTERVAL_MINUTE: "0"
  },
};

const AppConfigsVariableReducer: Reducer<
  AppConfigsResponse,
GetConfigVariablesDispatchTypes> = (state = initialState, action) => {
  switch (action.type) {
    case GetConfigVariablesActionDispatchTypes.GET_CONFIG_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case GetConfigVariablesActionDispatchTypes.GET_CONFIG_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case GetConfigVariablesActionDispatchTypes.GET_CONFIG_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
  }
  return state;
};

export default AppConfigsVariableReducer;
